import { jsx as a } from "react/jsx-runtime";
import t from "../SfIconBase/SfIconBase.mjs";
import { SfIconSize as n } from "@storefront-ui/shared";
function m({
  size: o = n.base,
  viewBox: r = "0 0 24 24",
  ...e
}) {
  return /* @__PURE__ */ a(t, { size: o, viewBox: r, "data-testid": "expand-more", ...e, children: /* @__PURE__ */ a("path", { d: "M17 9.003a1 1 0 0 0-1.41 0l-3.885 3.876L7.82 9.003a.998.998 0 0 0-1.41 1.411l4.588 4.588a1 1 0 0 0 1.414 0L17 10.414a.997.997 0 0 0 0-1.41" }) });
}
export {
  m as default
};
